webpackJsonp([216929306842663],{

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 1/4/18
	 */
	var Offerings = function Offerings(_ref) {
	  var gridItems = _ref.gridItems;
	  return _react2.default.createElement(
	    'div',
	    { className: 'columns is-multiline' },
	    gridItems.map(function (item) {
	      return _react2.default.createElement(
	        'div',
	        { key: item.image, className: 'column is-6', style: { borderRadius: '5px' } },
	        _react2.default.createElement(
	          'section',
	          { className: 'section' },
	          _react2.default.createElement(
	            'p',
	            { className: 'has-text-centered' },
	            _react2.default.createElement('img', { alt: '', src: item.image })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            item.text
	          )
	        )
	      );
	    })
	  );
	};
	
	Offerings.propTypes = {
	  gridItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    image: _propTypes2.default.string,
	    text: _propTypes2.default.string
	  }))
	};
	
	exports.default = Offerings;
	module.exports = exports['default'];

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 1/4/18
	 */
	var Testimonials = function Testimonials(_ref) {
	  var testimonials = _ref.testimonials;
	  return _react2.default.createElement(
	    'div',
	    null,
	    testimonials.map(function (testimonial, id) {
	      return _react2.default.createElement(
	        'article',
	        { className: 'message', key: id },
	        _react2.default.createElement(
	          'div',
	          { className: 'message-body' },
	          testimonial.quote,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'cite',
	            null,
	            ' \u2013 ',
	            testimonial.author
	          )
	        )
	      );
	    })
	  );
	};
	
	Testimonials.propTypes = {
	  testimonials: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    quote: _propTypes2.default.string,
	    author: _propTypes2.default.string
	  }))
	};
	
	exports.default = Testimonials;
	module.exports = exports['default'];

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.HomePageTemplate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Offerings = __webpack_require__(141);
	
	var _Offerings2 = _interopRequireDefault(_Offerings);
	
	var _Testimonials = __webpack_require__(145);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomePageTemplate = exports.HomePageTemplate = function HomePageTemplate(_ref) {
	  var title = _ref.title,
	      heading = _ref.heading,
	      description = _ref.description,
	      offerings = _ref.offerings,
	      meta_title = _ref.meta_title,
	      sub_title = _ref.sub_title,
	      meta_description = _ref.meta_description,
	      testimonials = _ref.testimonials;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        meta_title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: meta_description })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-primary is-bold' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-10 is-offset-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'title' },
	                  title
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'subtitle' },
	                  sub_title
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'section section--gradient' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-10 is-offset-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'content' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'has-text-weight-semibold is-size-2' },
	                    heading
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    description
	                  )
	                ),
	                _react2.default.createElement(_Offerings2.default, { gridItems: offerings.blurbs }),
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'has-text-weight-semibold is-size-2' },
	                  'Testimonials'
	                ),
	                _react2.default.createElement(_Testimonials2.default, { testimonials: testimonials })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}; /**
	    * Created by vaibhav on 31/3/18
	    */
	
	
	HomePageTemplate.propTypes = {
	  title: _propTypes2.default.string,
	  meta_title: _propTypes2.default.string,
	  meta_description: _propTypes2.default.string,
	  sub_title: _propTypes2.default.string,
	  heading: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  offerings: _propTypes2.default.shape({
	    blurbs: _propTypes2.default.array
	  }),
	  testimonials: _propTypes2.default.array
	};
	
	var HomePage = function HomePage(_ref2) {
	  var data = _ref2.data;
	  var frontmatter = data.markdownRemark.frontmatter;
	
	  console.log(frontmatter);
	  return _react2.default.createElement(HomePageTemplate, {
	    sub_title: frontmatter.sub_title,
	    title: frontmatter.title,
	    meta_title: frontmatter.meta_title,
	    meta_description: frontmatter.meta_description,
	    heading: frontmatter.heading,
	    description: frontmatter.description,
	    offerings: frontmatter.offerings,
	    testimonials: frontmatter.testimonials
	  });
	};
	
	HomePage.propTypes = {
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.shape({
	      frontmatter: _propTypes2.default.object
	    })
	  })
	};
	
	exports.default = HomePage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-home-page-js-51e157e08c1a6332fa54.js